const baseWidth = 1140

let defaultViewport, isLandscape
const isIosMob = (new RegExp(/iphone/i)).test(navigator.userAgent)
const isIosTab = (new RegExp(/ipad/i)).test(navigator.userAgent) || (new RegExp(/macintosh/i)).test(navigator.userAgent)
const isAndMob = (new RegExp(/android.*?mobile/i)).test(navigator.userAgent)
const isAndTab = (new RegExp(/android.*?^mobile/i)).test(navigator.userAgent)
const longlen = Math.max(window.innerHeight, window.innerWidth)

if(window.ontouchstart !== void 0){
  const loop = setInterval(() => {
    if(document.readyState === 'loading'){
      return
    }
  
    clearInterval(loop)
    defaultViewport = document.querySelector("meta[name='viewport']").getAttribute('content')
  
    window.addEventListener('resize', () => {
      setViewport()
    })
  
    setViewport()
  }, 50)
}

const setViewport = () => {
  const viewports = {
    iosMob: `width=${baseWidth}`,
    andMob: `initial-scale=${longlen / baseWidth}, width=device-width, minimum-scale=${longlen / baseWidth}, maximum-scale=3.0, user-scalable=yes`,
  }
  if(window.innerHeight < window.innerWidth && isLandscape !== true){
    document.body.classList.add('landscape')
    document.body.classList.remove('portrait')
    if(isIosMob){
      document.querySelector("meta[name='viewport']").setAttribute('content', viewports.iosMob)
    }else if(isAndMob){
      document.querySelector("meta[name='viewport']").setAttribute('content', viewports.andMob)
    }

  }else if(window.innerWidth < window.innerHeight && isLandscape !== false){
    document.body.classList.add('portrait')
    document.body.classList.remove('landscape')
    document.querySelector("meta[name='viewport']").setAttribute('content', defaultViewport)

  }
}
